// extracted by mini-css-extract-plugin
export default {"legendIndicator":"yma-z","legendNew":"zma-z"};